function ShippingAndDelivery() {
  return (
    <section id="shipping-delivery" className="bg-light">
      <div
        className="container pt-5 text-dark pb-md-5"
        style={{ maxWidth: "1000px" }}
      >
        <h2 className="color-blue text-center">
          <strong>Shipping & Delivery Policy</strong>
        </h2>

        <p className="lh-lg">
          At <strong>Vyomscode</strong>, we offer digital services such as website development, mobile
          applications, software solutions, and design services. As a service-based company, we do
          <strong> not ship any physical products</strong>. All deliverables are provided digitally and electronically.
          <br />
          <br />
          <h5 className="mb-0">1. Nature of Delivery</h5>
          All projects and services are delivered <strong>digitally</strong> via email, cloud storage,
          secure links, or directly uploaded to the client’s server or domain as discussed.
          <br />
          There is <strong>no physical shipping</strong> involved in any of our services.
          <br />
          <br />
          <h5 className="mb-0">2. Project Delivery Timeline</h5>
          Each project comes with a <strong>mutually agreed timeline</strong>, which is discussed and
          confirmed at the time of project onboarding.
          <br />
          We are committed to delivering the project <strong>within the agreed timeline</strong>, provided
          that all necessary inputs (such as content, approvals, and materials) are received from the client
          on time.
          <br />
          Delays from the client’s side may result in an extended delivery period.
          <br />
          <br />
          <h5 className="mb-0">3. Mode of Delivery</h5>
          Depending on the type of service, delivery will be made in one or more of the following formats:
          <br />
          - Live website or app deployment <br />
          - Source code or design files sent via email or shared drive <br />
          - Admin panel credentials and documentation shared securely <br />
          - Final reports or assets sent in PDF, DOC, or ZIP formats
          <br />
          <br />
          <h5 className="mb-0">4. Confirmation of Delivery</h5>
          Once the project is delivered as per the scope of work, the client will receive a{" "}
          <strong>Delivery Confirmation</strong> via email or formal message.
          <br />
          Any minor post-delivery revisions (if included in the package) will be completed within the
          support timeline defined in the agreement.
          <br />
          <br />
          <h5 className="mb-0">5. No Physical Delivery</h5>
          Vyomscode does <strong>not engage in logistics, courier, or physical product delivery</strong> of
          any kind.
          <br />
          Please do not expect shipping-related updates, as all services are electronically managed.
          <br />
          <br />
          <h5 className="mb-0">Need Help?</h5>
          If you have any questions about your service delivery or need updates, feel free to contact us at:
          <br />
          📧 support@vyomscode.com
          <br />
          📞 +91 8726324687
        </p>
      </div>
    </section>
  );
}

export default ShippingAndDelivery;
